import { Box, Container, Typography } from "@mui/material";
import Step from "./Step";
import StepCard from "./StepCard";

const OfferingsSection = () => {
  return (
    <Box
      sx={{
        mt: { xs: 4, md: 4 },
        width: "100%",
        minHeight: { xs: "auto", md: "1500px", lg: "100%" },
        background:
          "linear-gradient(180deg, #1B7BC6 0%, rgba(20, 149, 66, 0.82) 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: { xs: 3, md: 6 },
        borderRadius: "24px",
      }}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              textAlign: "center",
              mb: { xs: 4, md: 8 },
              fontFamily: "Inter, sans-serif",
              color: "#FFF",
              fontStyle: "normal",
              fontWeight: 900,
              lineHeight: "130%",
              fontSize: {
                xs: "25px",
                sm: "28px",
                md: "50px",
              },
              width: "100%",
            }}
          >
            What does a day with Foxtox look like?
          </Typography>

          <Box
            sx={{
              width: "100%",
              maxWidth: "1200px",
              margin: "0 auto",
              position: "relative",
              "&:before": {
                position: "absolute",
                left: "20px",
                top: "40px",
                fontFamily: "Inter, sans-serif",
                bottom: "40px",
                width: "2px",
                background:
                  "linear-gradient(to bottom, #17B745, rgba(23, 183, 69, 0.2))",
                zIndex: 1,
                display: { xs: "none", md: "block" },
              },
            }}
          >
            <Step number={1} title="Step 1"></Step>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                gap: 4,
                mt: 5,
                pl: { xs: 0, md: "76px" },
                pr: { xs: 0, md: 4 },
              }}
            >
              <StepCard
                number={1}
                image="/assets/AdvisorTradeWhatsapp.jpeg"
                imageAlt="Advisor added New trade"
                label="WhatsApp Notification on new trade calls"
              />
              <StepCard
                number={2}
                image="/assets/FoxtoxDashboard.jpeg"
                imageAlt="Foxtox Dashboard"
                label="Evaluate and choose which trade suits you. Click 'Notify Me' and forget!"
              />
            </Box>

            <Step number={2} title="Step 2"></Step>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                gap: 4,
                mt: 5,
                pl: { xs: 0, md: "76px" },
                pr: { xs: 0, md: 4 },
              }}
            >
              <StepCard
                number={3}
                image="/assets/TimeToEnterWhatsapp.jpeg"
                imageAlt="Time to Enter"
                label="WhatsApp Notification when it's time to enter"
              />
              <StepCard
                number={4}
                image="/assets/PlaceOrderZerodha.jpeg"
                imageAlt="Place order screen (Zerodha app)"
                label="Place relevant order(s) on your Broker app. Back to work!"
              />
            </Box>

            <Step number={3} title="Step 3"></Step>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                gap: 4,
                mt: 5,
                pl: { xs: 0, md: "76px" },
                pr: { xs: 0, md: 4 },
              }}
            >
              <StepCard
                number={5}
                image="/assets/BookProfitsWhatsapp.jpeg"
                imageAlt="Book Profits"
                label="WhatsApp Notification when it's time to book profits / losses."
              />
              <StepCard
                number={6}
                image="/assets/PositionsZerodha.png"
                imageAlt="Positions Zerodha"
                label="Open Broker app, evaluate & exit trade. DONE!"
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default OfferingsSection;
